import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CloseIcon from '../../../../../assets/icons/close.svg';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, payment, program} = contexts;

  const data: EventData = {};

  if (payment && actor) {
    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.title = i18n.t('notifications:payment_refund_failed.title', {
      actorName: actor.name,
      price: getPriceString({
        currency: Currency[payment.currency],
        price: payment.amount,
      }),
    });
  }

  data.icon = CloseIcon;
  data.iconGradient = 'danger';

  return data;
};
